import React from "react";
import { useTranslation } from "react-i18next";

import css from "../features_list_page.scss";

type DefaultColumnProps = {
  attribute: boolean;
};

export const DefaultCell = ({ attribute }: DefaultColumnProps): JSX.Element => {
  const { t } = useTranslation("admin");

  const label = attribute ? t("status.active") : t("status.inactive");
  return <span className={attribute ? css.cellTrue : css.cellFalse}>{label}</span>;
};
